import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Outlet } from "@tanstack/react-router";
import { useState } from "react";
import useResponsive from "src/hooks/useResponsive";

import { HEADER, NAVBAR } from "../../config";
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
import Context, { ContextType } from "./context";
import DrawerMenuBtn from "./DrawerMenuBtn";
import NavbarVertical from "./NavbarVertical/NavbarVertical";

// ----------------------------------------------------------------------

type MainStyleProps = {
	collapseClick: boolean;
};

const MainStyle = styled("main", {
	shouldForwardProp: (prop) => prop !== "collapseClick"
})<MainStyleProps>(({ collapseClick, theme }) => ({
	flexGrow: 1,
	paddingTop: HEADER.MOBILE_HEIGHT,
	paddingBottom: HEADER.MOBILE_HEIGHT + 24,
	paddingLeft: 6,
	paddingRight: 6,
	[theme.breakpoints.up("lg")]: {
		paddingLeft: 16,
		paddingRight: 16,
		paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT,
		paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
		width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
		transition: theme.transitions.create("margin-left", {
			duration: theme.transitions.duration.shorter
		}),
		...(collapseClick && {
			marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH
		})
	}
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
	const [open, setOpen] = useState(false);

	const { collapseClick, isCollapse } = useCollapseDrawer();
	const isDownLg = useResponsive("down", "lg");

	const contextValue: ContextType = {
		isCollapse,
		isOpenSidebar: open,
		actions: {
			onOpenSidebar: () => setOpen(true),
			onCloseSidebar: () => setOpen(false)
		}
	};

	return (
		<Box
			sx={{
				display: { lg: "flex" },
				minHeight: { lg: 1 }
			}}
		>
			<Context.Provider value={contextValue}>
				{isDownLg && <DrawerMenuBtn onClick={() => setOpen(true)} />}
				<NavbarVertical />
				<MainStyle collapseClick={collapseClick}>
					<Outlet />
				</MainStyle>
			</Context.Provider>
		</Box>
	);
}
